import { SubStore } from 'store/types';

export interface SecItem {
  effTs: string;
  id: string;
  name: string;
  [metricName: string]: any;
}

export interface SecAPIResult {
  results: SecItem[];
}

export interface PriceHistoryMetric {
  [secId: string]: PriceHistoryItem;
}
export interface PriceHistoryItem {
  [metricName: string]: number[][];
}

type IndexorEquityId = string;
export interface Manifest {
  [secId: string]: IndexorEquityId;
}
export interface PriceHistory extends SubStore {
  manifest: Manifest;
  results: PriceHistoryMetric;
}

const priceHistoryStore: PriceHistory = {
  manifest: {},
  results: {},
  status: 'init',
};

export { priceHistoryStore };
